(function () {
  'use strict';

  function initBundleSelector() {
    var forms = document.querySelectorAll('.lv-bundle-form');
    forms.forEach(function (form) {
      var radios = form.querySelectorAll('[data-lv-bundle-radio]');
      var variantInput = form.querySelector('[data-lv-variant-input]');
      var buyButton = form.querySelector('[data-lv-buy-button]');
      var buyButtonText = form.querySelector('[data-lv-buy-button-text]');
      var bonusItems = form.parentElement.querySelectorAll('[data-lv-bonus-item]');
      var subscribeToggle = form.querySelector('[data-lv-subscribe-toggle]');
      var sellingPlanInput = form.querySelector('[data-lv-selling-plan-input]');
      var sellingPlanDataEl = form.querySelector('[data-lv-selling-plan-data]');
      var sellingPlanData = null;

      if (sellingPlanDataEl) {
        try {
          sellingPlanData = JSON.parse(sellingPlanDataEl.textContent);
        } catch (e) {
          sellingPlanData = null;
        }
      }

      if (!radios.length) return;

      // Liquid renders the first price; this rewrites it on every bundle or
      // subscription change, so both have to agree on the currency prefix.
      // It comes from the form so the snippet stays the single source.
      var moneyPrefix = form.dataset.moneyPrefix || '$';

      function formatMoney(cents) {
        return moneyPrefix + (cents / 1).toFixed(2);
      }

      function isSubscribing() {
        return !!(subscribeToggle && subscribeToggle.checked);
      }

      // Every bundle card shows the subscription price while the toggle is on,
      // so the discount is visible on the options themselves — not just on the
      // hidden line item that actually goes to the cart.
      function repriceCards() {
        var subscribing = isSubscribing();
        radios.forEach(function (r) {
          var option = r.closest('.lv-bundle-option');
          if (!option) return;

          var priceEl = option.querySelector('.lv-bundle-option__price');
          var compareEl = option.querySelector('.lv-bundle-option__compare');
          var saveEl = option.querySelector('.lv-bundle-option__save');

          var oneTime = parseFloat(r.dataset.price || '0');
          var oneTimeCompare = parseFloat(r.dataset.comparePrice || '0');
          var price = oneTime;
          var compare = oneTimeCompare;

          if (subscribing && sellingPlanData) {
            var plan = sellingPlanData.variantPlans[r.dataset.variantId];
            if (plan && plan.price !== null) {
              price = parseFloat(plan.price);
              // Against the one-time price, so the saving reads as the
              // subscription benefit rather than the original RRP.
              compare = oneTime;
            }
          }

          if (priceEl) priceEl.textContent = formatMoney(price);
          if (compareEl) {
            if (compare > price) {
              compareEl.textContent = formatMoney(compare);
              compareEl.style.display = '';
            } else {
              compareEl.style.display = 'none';
            }
          }
          if (saveEl) {
            // A savings line typed in the Customizer is a deliberate merchant
            // claim, so it stays put on the one-time price. Subscription mode
            // still recalculates, because there the number would otherwise
            // contradict the price shown right next to it.
            var fixedSave = saveEl.dataset.fixedSave;
            if (fixedSave && !subscribing) {
              saveEl.textContent = fixedSave;
              saveEl.style.display = '';
              return;
            }
            if (compare > price) {
              var pct = Math.round(((compare - price) / compare) * 100);
              saveEl.textContent = 'Save ' + pct + '%';
              saveEl.style.display = '';
            } else {
              saveEl.style.display = 'none';
            }
          }
        });
      }

      function selectBundle(radio) {
        radios.forEach(function (r) {
          var option = r.closest('.lv-bundle-option');
          if (option) option.classList.toggle('is-selected', r === radio);
        });

        repriceCards();

        if (variantInput) variantInput.value = radio.dataset.variantId;

        var price = parseFloat(radio.dataset.price || '0');
        var subscribing = isSubscribing();

        if (subscribing && sellingPlanData) {
          var plan = sellingPlanData.variantPlans[radio.dataset.variantId];
          if (plan && plan.price !== null) {
            price = parseFloat(plan.price);
          }
        }

        if (sellingPlanInput) {
          sellingPlanInput.value = (subscribing && sellingPlanData) ? sellingPlanData.sellingPlanId : '';
        }

        if (buyButtonText) {
          var prefix = buyButton ? (buyButton.dataset.ctaPrefix || 'Add to cart') : 'Add to cart';
          var showPrice = buyButton && buyButton.dataset.showPrice === 'true';
          if (showPrice) {
            buyButtonText.textContent = prefix + ' — ' + formatMoney(price);
          } else {
            buyButtonText.textContent = prefix;
          }
        }

        var tier = parseInt(radio.dataset.bonusTier || '0', 10);
        bonusItems.forEach(function (item) {
          var unlockTier = parseInt(item.dataset.unlockTier || '0', 10);
          var unlocked = tier >= unlockTier;
          item.classList.toggle('is-unlocked', unlocked);
          var nameEl = item.querySelector('[data-lv-bonus-name]');
          if (nameEl) {
            // The locked label is whatever Liquid rendered, captured once.
            // Hardcoding the word here left every translated storefront
            // showing "Locked" the moment this ran.
            if (!nameEl.dataset.lockedLabel) {
              nameEl.dataset.lockedLabel = nameEl.textContent.trim();
            }
            nameEl.textContent = unlocked
              ? (item.dataset.bonusName || '')
              : nameEl.dataset.lockedLabel;
          }
        });

        updateStickyBar(radio, subscribing, sellingPlanData);
      }

      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          selectBundle(radio);
        });
      });

      if (subscribeToggle) {
        subscribeToggle.addEventListener('change', function () {
          var selected = form.querySelector('[data-lv-bundle-radio]:checked');
          if (selected) selectBundle(selected);
        });
      }

      var defaultRadio = form.querySelector('[data-lv-bundle-radio]:checked') || radios[0];
      if (defaultRadio) selectBundle(defaultRadio);

      form.addEventListener('submit', function () {
        var selected = form.querySelector('[data-lv-bundle-radio]:checked');
        var currency = buyButton ? buyButton.dataset.currency : '';
        document.dispatchEvent(new CustomEvent('lumvelle:add_to_cart', {
          detail: {
            variantId: selected ? selected.dataset.variantId : null,
            value: selected ? parseFloat(selected.dataset.price) : 0,
            currency: currency,
            name: selected ? selected.dataset.bundleLabel : ''
          }
        }));
        document.dispatchEvent(new CustomEvent('lumvelle:initiate_checkout', {
          detail: {
            value: selected ? parseFloat(selected.dataset.price) : 0,
            currency: currency
          }
        }));
      });
    });
  }

  function updateStickyBar(radio, subscribing, sellingPlanData) {
    var bar = document.querySelector('[data-lv-sticky-bar]');
    if (!bar) return;
    var priceEl = bar.querySelector('[data-lv-sticky-price]');
    var button = bar.querySelector('[data-lv-sticky-buy]');
    var price = parseFloat(radio.dataset.price);
    if (subscribing && sellingPlanData) {
      var plan = sellingPlanData.variantPlans[radio.dataset.variantId];
      if (plan && plan.price !== null) price = parseFloat(plan.price);
    }
    if (priceEl) priceEl.textContent = 'From $' + price.toFixed(2);
    if (button) button.dataset.variantId = radio.dataset.variantId;
  }

  function initStickyBar() {
    var bar = document.querySelector('[data-lv-sticky-bar]');
    var mainButton = document.querySelector('[data-lv-buy-button]');
    if (!bar || !mainButton) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });

    observer.observe(mainButton);

    var stickyButton = bar.querySelector('[data-lv-sticky-buy]');
    if (stickyButton) {
      stickyButton.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById('lv-bundle-selector');
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      });
    }
  }

  function initIngredientCards() {
    document.querySelectorAll('.lv-ingredient-card').forEach(function (card) {
      card.addEventListener('click', function () {
        card.classList.toggle('is-expanded');
      });
      card.setAttribute('tabindex', '0');
      card.setAttribute('role', 'button');
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          card.classList.toggle('is-expanded');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  function run() {
    initBundleSelector();
    initStickyBar();
    initIngredientCards();
  }
})();
